<script>
  import { arrayRemove } from "@firebase/firestore";


class info{
    constructor(value){
        this.value = value;
    }
    valid(values){
        console.log(values);
        
    }
    view(){
        console.log(this.value );
        
    }
}

class vector extends info{
    constructor(value,v){
        super(value);
        this.v = v;
    }

    getV(){
        console.log('Value: ',this.value,'v: ',this.v);
    }

    setV(v){
        this.v = v;
    }
}

let value = new vector({
    DisposableStack:"31",
    satisfies:32
},{
    DisposableStack:"31",
    satisfies:32
});

let mesas = [1,-1,0,5]



function nomb(_arrayNumbers,callback){
    let newarray = []
    _arrayNumbers.forEach(element => {
        if (callback(element)) {
            newarray.push(element)
            
        }
    });
    console.log(newarray);
    return true;
}


let mypro = new Promise(function(myResolve,myReject) {
    if(nomb(mesas,(x) => x>=0 )) {
        myResolve(true);
    }else{
        myReject(false); 
    }
    });

mypro.then(
  function(value) {
    console.log('true: ',value);
    
  },
  function(error) {
    console.log(value);
  }
);

fetch('https://pokeapi.co/api/v2/pokemon/ditto')
  .then(response => response.json())
  .then(data => console.log(data));


</script>


<h1>1</h1>

<button on:click={() => {value.view()}}> view </button>
<button on:click={() => {value.view(value)}}> valid </button>
<button on:click={() => {value.getV()}}> getV </button>